<script setup>
defineProps({
  title: {
    type: String,
  },
  summary: {
    type: String,
  },
})
</script>

<template>
  <div
    v-if="title || summary"
    class="block-header"
  >
    <div class="prose">
      <h2 v-if="title">
        {{ title }}
      </h2>
      <div
        class="block-header__summary"
        v-html="summary || ''"
      />
    </div>
  </div>
</template>

<style lang="scss">
@use '@/assets/css/blocks/block-header.scss';
</style>
